export const Declared = {
  "es-MX": "DECLARADO",
  "un-US": "VALIDATED",
  "du-NL": "VALIDATED",
  "ja-JP": "VALIDATED",
  "fr-FR": "VALIDATED",
  "zh-CN": "VALIDATED",
  "kr-KR": "VALIDATED",
  "pt-PT": "ATESTADO",
}